import { getPlatformLabel } from '../utils/platformDetection';

interface PlatformBadgeProps {
  os: string;
  arch: string;
  className?: string;
}

/**
 * Displays a platform badge showing OS and architecture
 * Example: "Windows 64-bit", "macOS (Apple Silicon)", "Linux 32-bit"
 */
export function PlatformBadge({ os, arch, className = '' }: PlatformBadgeProps) {
  // Get OS icon/emoji
  const getOsIcon = (osName: string): string => {
    switch (osName.toLowerCase()) {
      case 'windows':
        return '🪟';
      case 'macos':
        return '🍎';
      case 'linux':
        return '🐧';
      default:
        return '💻';
    }
  };

  const icon = getOsIcon(os);
  const label = getPlatformLabel(os, arch);

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-md bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 ${className}`}
      title={`Platform: ${label}`}
    >
      <span aria-hidden="true">{icon}</span>
      <span>{label}</span>
    </span>
  );
}
